module.exports = __webpack_public_path__ + "img/annualIntroduction.e8d90cd3.jpg";